<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-xl-6">
        <div class="card">
          <div class="header">
            <h4 class="title">{{'insert-client-company.client' | translate}}</h4>
          </div>
          <div class="content">
            <form [formGroup]="clientForm" class="needs-validation">
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.first-name' | translate}} *"
                    name="firstName" id="firstName" placeHolder="{{'insert-client-company.first-name' | translate}}"
                    formControlNameValue="firstName" [formGroup]="clientForm" required="true" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.last-name' | translate}} *"
                    name="lastName" id="lastName" formControlNameValue="lastName" [formGroup]="clientForm"
                    placeHolder="{{'insert-client-company.last-name' | translate}}"
                    [error]="clientErrorArray['lastName']" required="true" ngDefaultControl></app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="email"
                    label="{{'insert-client-company.first-email' | translate}} *" name="firstEmail" id="firstEmail"
                    placeHolder="{{'insert-client-company.first-email' | translate}}" formControlNameValue="firstEmail"
                    [error]="clientErrorArray['firstEmail']" [formGroup]="clientForm" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="email"
                    label="{{'insert-client-company.second-email' | translate}}" name="secondEmail" id="secondEmail"
                    placeHolder="{{'insert-client-company.second-email' | translate}}"
                    formControlNameValue="secondEmail" [error]="clientErrorArray['secondEmail']"
                    [formGroup]="clientForm" ngDefaultControl></app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text"
                    label="{{'insert-client-company.first-phone' | translate}} *" name="firstPhone" id="firstPhone"
                    placeHolder="{{'insert-client-company.first-phone' | translate}}" required="true"
                    formControlNameValue="firstPhone" [error]="clientErrorArray['firstPhone']" [formGroup]="clientForm"
                    ngDefaultControl></app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.second-phone' | translate}}"
                    name="secondPhone" id="secondPhone"
                    placeHolder="{{'insert-client-company.second-phone' | translate}}"
                    formControlNameValue="secondPhone" [error]="clientErrorArray['secondPhone']"
                    [formGroup]="clientForm" ngDefaultControl></app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-textarea label="{{'insert-client-company.notes' | translate}}" name="notes"
                    id="notes" formControlNameValue="notes" [error]="clientErrorArray['notes']" [formGroup]="clientForm"
                    ngDefaultControl></app-ng-form-group-textarea>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-6">
        <div class="card">
          <div class="header">
            <h4 class="title">{{'insert-client-company.company' | translate}}</h4>
          </div>
          <div class="content">
            <form [formGroup]="companyForm" class="needs-validation">
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text"
                    label="{{'insert-client-company.company-name' | translate}} *" name="name" id="name"
                    placeHolder="{{'insert-client-company.company-name' | translate}}" formControlNameValue="name"
                    [formGroup]="companyForm" required="true" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="email"
                    label="{{'insert-client-company.first-email' | translate}} *" name="companyFirstEmail"
                    id="companyFirstEmail" placeHolder="{{'insert-client-company.first-email' | translate}}"
                    required="true" formControlNameValue="firstEmail" [error]="companyErrorArray['firstEmail']"
                    [formGroup]="companyForm" ngDefaultControl></app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="email"
                    label="{{'insert-client-company.second-email' | translate}}" name="companySecondEmail"
                    id="companySecondEmail" placeHolder="{{'insert-client-company.second-email' | translate}}"
                    formControlNameValue="secondEmail" [error]="companyErrorArray['secondEmail']"
                    [formGroup]="companyForm" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text"
                    label="{{'insert-client-company.first-phone' | translate}} *" name="companyFirstPhone"
                    id="companyFirstPhone" placeHolder="{{'insert-client-company.first-phone' | translate}}"
                    required="true" formControlNameValue="firstPhone" [error]="companyErrorArray['firstPhone']"
                    [formGroup]="companyForm" ngDefaultControl></app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.second-phone' | translate}}"
                    name="companySecondPhone" id="companySecondPhone"
                    placeHolder="{{'insert-client-company.second-phone' | translate}}"
                    formControlNameValue="secondPhone" [error]="companyErrorArray['secondPhone']"
                    [formGroup]="companyForm" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.vat' | translate}}"
                    name="vat" id="vat" placeHolder="{{'insert-client-company.vat' | translate}}" required="true"
                    formControlNameValue="vat" [error]="companyErrorArray['vat']" [formGroup]="companyForm"
                    ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.fiscal-code' | translate}}"
                    name="fiscalCode" id="fiscalCode" placeHolder="{{'insert-client-company.fiscal-code' | translate}}"
                    formControlNameValue="fiscalCode" [error]="companyErrorArray['fiscalCode']"
                    [formGroup]="companyForm" ngDefaultControl></app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="email" label="{{'insert-client-company.pec-email' | translate}}"
                    name="pecEmail" id="pecEmail" placeHolder="{{'insert-client-company.pec-email' | translate}}"
                    formControlNameValue="pecEmail" [error]="companyErrorArray['pecEmail']" [formGroup]="companyForm"
                    ngDefaultControl></app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.isd-number' | translate}}"
                    name="isdNumber" id="isdNumber" placeHolder="{{'insert-client-company.isd-number' | translate}}"
                    formControlNameValue="isdNumber" [error]="companyErrorArray['isdNumber']" [formGroup]="companyForm"
                    ngDefaultControl></app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.address' | translate}}"
                    name="address" id="address" required="true"
                    placeHolder="{{'insert-client-company.address' | translate}}" formControlNameValue="address"
                    [error]="companyErrorArray['address']" [formGroup]="companyForm" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.city' | translate}}"
                    name="city" id="city" required="true" placeHolder="{{'insert-client-company.city' | translate}}"
                    formControlNameValue="city" [error]="companyErrorArray['city']" [formGroup]="companyForm"
                    ngDefaultControl></app-ng-form-group-input>
                </div>
                <div class="col">
                  <app-ng-form-group-input inputType="text" label="{{'insert-client-company.postal-code' | translate}}"
                    name="postalCode" id="postalCode" required="true"
                    placeHolder="{{'insert-client-company.postal-code' | translate}}" formControlNameValue="postalCode"
                    [error]="companyErrorArray['postalCode']" [formGroup]="companyForm" ngDefaultControl>
                  </app-ng-form-group-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-ng-form-group-select label="{{'insert-client-company.country' | translate}}" name="country"
                    id="country" required="true" formControlNameValue="country" [error]="companyErrorArray['country']"
                    [formGroup]="companyForm" [options]="clientCountryArray" ngDefaultControl>
                  </app-ng-form-group-select>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
